import React from 'react';
import { utcToGmt } from '../../components/utils';

import * as S from './styles';
import {
  DocumentLabel,
  DocumentNumber,
  PaymentLocation,
  PaymentInstructions,
  DateText,
  InvoiceFines,
  InvoiceStatus,
  InvoiceInterest
} from '../../components';

const Guarantor = ({ dataBilling }) =>
  dataBilling.guarantorDocumentNumber ? (
    <>
      <S.TitleWithMargin>Beneficiário:</S.TitleWithMargin>
      <S.SimpleTextWithoutSpace>
        {dataBilling?.guarantorName}
      </S.SimpleTextWithoutSpace>
      <S.Text>
        <DocumentLabel number={dataBilling.guarantorDocumentNumber} />:
        <S.Space/>
        <S.SimpleTextWithoutSpace>
          <DocumentNumber number={dataBilling.guarantorDocumentNumber} />
        </S.SimpleTextWithoutSpace>
      </S.Text>
    </>
  ) : (
    <></>
  );

export const RecipientData = ({ dataBilling }) => {
  return (
    <>
      <S.RecipientDataWrapper>
        <S.RecipientDataContainer>
          <Guarantor dataBilling={dataBilling} />
          {dataBilling?.guarantorDocumentNumber ? (
            <S.TitleWithMargin>Intermediado por:</S.TitleWithMargin>
          ) : (
            <S.TitleWithMarginBotton>Intermediado por:</S.TitleWithMarginBotton>
          )}
          <S.SimpleTextWithoutSpace>
            {dataBilling.recipientName}
          </S.SimpleTextWithoutSpace>
          <S.Text>
            <DocumentLabel number={dataBilling.recipientDocumentNumber} />:
            <S.Space />
            <S.SimpleTextWithoutSpace>
              <DocumentNumber number={dataBilling.recipientDocumentNumber} />
            </S.SimpleTextWithoutSpace>
          </S.Text>
          <S.RecipientBankDetails>
            <div>
              <S.TitleWithMargin>Nosso Número</S.TitleWithMargin>
              <S.SimpleTextWithoutSpace>
                {dataBilling.ourNumber}
              </S.SimpleTextWithoutSpace>
            </div>
            <div>
              <S.TitleWithMargin>
                Número do Documento
              </S.TitleWithMargin>
              <S.SimpleTextWithoutSpace>
                {dataBilling?.document}
              </S.SimpleTextWithoutSpace>
            </div>
          </S.RecipientBankDetails>
        </S.RecipientDataContainer>

        <S.Divider className='disable-mobile' />

        <S.RecipientDataContainer>
          <S.TitleWithMargin>Data de Emissão</S.TitleWithMargin>
          <S.TextWithMarginBotton>
            <DateText date={utcToGmt(dataBilling.invoiceCreatedDate)} />
          </S.TextWithMarginBotton>
          <S.TitleWithMargin>Local de Pagamento</S.TitleWithMargin>
          <S.TextWithMarginBotton>
            <PaymentLocation />
          </S.TextWithMarginBotton>
          <S.TitleWithMargin>Instruções</S.TitleWithMargin>
          <S.SimpleTextWithoutSpace>
            <PaymentInstructions dataBilling={dataBilling} />
          </S.SimpleTextWithoutSpace>
          <S.SimpleTextWithoutSpace>
            <InvoiceFines dataBilling={dataBilling} />
          </S.SimpleTextWithoutSpace>
          <S.SimpleTextWithoutSpace>
            <InvoiceInterest
              interestPercent={dataBilling.invoiceInterestPercent}
              dueDate={dataBilling.invoiceDueDate}
            />
          </S.SimpleTextWithoutSpace>
          <S.Status>
            <span>
              <InvoiceStatus status={dataBilling.invoiceStatus} />
            </span>
          </S.Status>
        </S.RecipientDataContainer>
      </S.RecipientDataWrapper>
      <S.Container>
        <S.Spacer className='spacer' />
        <S.TitleWithMargin>Pagador</S.TitleWithMargin>
        <S.SimpleTextWithoutSpace>
          {dataBilling.payerName}
        </S.SimpleTextWithoutSpace>
        <S.Text>
          <DocumentLabel number={dataBilling.payerDocumentNumber} />:
          <S.Space />
          <S.SimpleTextWithoutSpace>
            <DocumentNumber number={dataBilling.payerDocumentNumber} />
          </S.SimpleTextWithoutSpace>
        </S.Text>
        <S.SimpleTextWithoutSpace>
          {dataBilling.payerAddress}
        </S.SimpleTextWithoutSpace>
      </S.Container>
    </>
  );
};
